import { Common, ApiBind } from './common.model';

export class IpGroup extends Common {

  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;

}
